export { default as ClientCoveragesDataTable } from "./ClientCoveragesDataTable";
export { default as ClientCoveragesPage } from "./ClientCoveragesPage";
export { default as BasicClientCoveragesFields } from "./BasicClientCoveragesFields";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/index.js